export default __webpack_public_path__ + "static/fit-colorectal-cancer-box@2x-28b18cff16381e42660d1310a40b0f86.png";